
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["fill-current",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8 1.333a6.667 6.667 0 110 13.334A6.667 6.667 0 018 1.333zm0 1.2a5.467 5.467 0 100 10.934A5.467 5.467 0 008 2.533zm-.107 7.2a.959.959 0 01.938.943.941.941 0 01-1.883-.01.959.959 0 01.945-.933zM6.015 5.3c1.068-1.216 2.918-1.193 3.892.033.513.638.596 1.791-.352 2.395-.164.104-.332.203-.499.303-.216.129-.407.262-.39.566a.267.267 0 01-.3.279H7.45c-.24.01-.334-.121-.344-.343a1.333 1.333 0 01.655-1.242c.25-.16.515-.296.76-.462.405-.266.39-.666-.024-.933a1.067 1.067 0 00-1.424.221c-.481.567-.503.407-.97.067-.469-.34-.522-.39-.087-.884z"}})])
          )
        }
      }
    